exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".uploader-unsupport{position:relative;z-index:10;overflow:hidden}", "", {"version":3,"sources":["/Users/didi/Documents/git/private/vue-uploader/src/components/unsupport.vue"],"names":[],"mappings":"AACA,oBACE,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAClB","file":"unsupport.vue","sourcesContent":["\n.uploader-unsupport {\n  position: relative;\n  z-index: 10;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05aa39f8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/unsupport.vue
// module id = 63
// module chunks = 0